<script>
    // выбор из пары

    export let wrapper;
    export let data;
    export let reward;

    let bonus = 0;
    let questions = [...data.options];
    let question = questions.shift();

    const handlerNext = (value) => {
        let qbtn = wrapper.querySelectorAll('button'),
            progress = wrapper.querySelector('.progress-bar');
    
        qbtn.forEach(el => {el.disabled = true});
    
        if (question.answer.toString() === value.toString()) {
            bonus += +question.bonus;
        }
    
        progress.style = 'width: ' + ((data.options.length - questions.length) * 100 / data.options.length) + '%';
    
        setTimeout(() => {
            qbtn.forEach(el => {el.disabled = false});
        
            if (questions.length) {
                question = questions.shift();
            } else {
                wrapper.querySelector('[data-question]').style.display = 'none';
                wrapper.querySelector('[data-answer]').style.display = 'block';
            }
        }, 1000);
    };
    
    const handlerCheck = () => {
        reward(bonus);
    }
</script>

<div data-question>
    <div class="progress mb-3">
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 0%"></div>
    </div>
    
    <div class="row mt-3">
        <div class="col-12 mb-1">
            <button type="button" class="btn btn-primary btn-block btn-lg" on:click={() => handlerNext(1)}>{question.variant_1}</button>
        </div>
        <div class="col-12 mb-1">
            <button type="button" class="btn btn-primary btn-block btn-lg" on:click={() => handlerNext(2)}>{question.variant_2}</button>
        </div>
    </div>
</div>

<div class="card" data-answer style="display: none">
    <div class="card-body">
        <h5 class="card-title text-md-center mb-1">Ответы</h5>
        <p class="text-md-center mb-2">Набрано баллов: {bonus}</p>
        <ul class="list-group text-center">
            {#each data.options as option, i}
                <li class="list-group-item">{option['variant_' + option.answer]}</li>
            {/each}
        </ul>
    </div>
    
    <div class="card-footer">
        <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerCheck}>Закончить</button>
    </div>
</div>
